export default __webpack_public_path__ + "static/media/pdf.7894e5a0.svg";